import React from "react";

const Footer = () => (
  <div className="container">
    <div className="footer">
      <p className="muted__text smaller__text">
        © All rights reserved. Maintained by
        <a
          className="link__decoration highlighted__text"
          target="_blank"
          rel="noopener noreferrer"
          href="https://3iinc.xyz"
        >
          {" "}
          3i INC.
        </a>
      </p>
    </div>
  </div>
);

export default Footer;
